import LogsList from "./components/LogsList";
import useLogsList from "./hooks/useLogsList";
import { useFilters } from "@/modules/common/filters";
import { FILTER_KEYS } from "@/modules/common/filters/keys";
import { ListAdminAuditLogsDto } from "@/service/dto/admin-audit-logs";
import { usePagination } from "@/modules/common/hooks/usePagination";

const Logs = () => {
  const filters = useFilters<ListAdminAuditLogsDto>({
    fields: [],
    filterKey: FILTER_KEYS.AUDIT_LOGS,
  });

  const { page, setPage, limit, setPageSize } = usePagination({
    initialPage: filters.queryParams.page ? Number(filters.queryParams.page) : undefined,
    defaultLimit: filters.queryParams.limit ? Number(filters.queryParams.limit) : undefined,
  });

  const {
    data: logs,
    isLoading,
    isFetching,
  } = useLogsList({
    ...filters.queryParams,
    limit,
    page,
  });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col">
          <p className="text-[22px] font-bold text-ui-primary">Logs / Auditoria / Monitoramento</p>
          <p className="text-[14px] text-ui-text-muted">
            Trilha completa de eventos, ações administrativas e saúde operacional da plataforma.
          </p>
        </div>
      </div>

      <div className="flex flex-col bg-white rounded-xl gap-4 p-4">
        <div className="flex flex-col">
          <p className="text-[16px] font-bold text-ui-primary">Eventos detalhados</p>
          <p className="text-[12px] text-ui-text-muted">Auditoria recente de ações administrativas no portal.</p>
        </div>

        <LogsList
          data={logs}
          isLoading={isLoading}
          isFetching={isFetching}
          onChangePage={setPage}
          onChangePageSize={(nextSize) => {
            setPageSize(nextSize);
            setPage(1);
          }}
        />
      </div>
    </div>
  );
};

export default Logs;
